import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import "./ServiceStyles.css";

function Service() {
  const sanctionsCards = [
    {
      title: "Program Assessment & Development",
      text: [
        "Comprehensive evaluation and policy creation tailored to defense operations.",
        "Build robust compliance frameworks that meet OFAC requirements while supporting business operations.",
      ],
    },
    {
      title: "Transaction Due Diligence",
      text: [
        "Expert screening and risk assessment for international deals and partnerships.",
        "Comprehensive sanctions screening using multiple databases with beneficial ownership analysis.",
      ],
    },
    {
      title: "Training & Education",
      text: [
        "Role-specific programs for executives, compliance teams, sales, and procurement.",
        "Interactive, practical training with defense industry examples and case studies.",
      ],
    },
    {
      title: "Voluntary Self-Disclosure Guidance",
      text: [
        "Strategic compliance guidance for internal investigations and remediation planning.",
      ],
      note: "Note: We work alongside your legal counsel. Actual VSD submissions require legal representation.",
    },
    {
      title: "Compliance Audits",
      text: [
        "Independent testing of sanctions controls with remediation priorities.",
        "Sample-based transaction review, documentation assessment, and control testing.",
      ],
    },
    {
      title: "Crisis Response & Incident Management",
      text: [
        "Immediate compliance support for sanctions incidents.",
      ],
      note: "Note: We coordinate with your legal counsel on matters involving regulatory agencies.",
    },
  ];

  const cfiusCards = [
    {
      title: "Risk Assessment & Structuring",
      text: [
        "Determine filing requirements and provide guidance on addressing national security concerns.",
        "Jurisdiction analysis, foreign investor assessment, and transaction structure recommendations.",
      ],
    },
    {
      title: "Filing Support & Preparation",
      text: [
        "Support CFIUS declaration and notice preparation alongside your legal counsel.",
      ],
      note: "Note: CFIUS filings are legal documents prepared by attorneys. We provide compliance support.",
    },
    {
      title: "Mitigation Planning & Implementation",
      text: [
        "Develop compliance frameworks for national security mitigation measures.",
        "Governance structures, operational controls, reporting systems, and security protocols.",
      ],
    },
    {
      title: "FOCI Compliance Support",
      text: [
        "Maintain facility clearances with foreign ownership through compliance program development.",
        "SSA, Proxy, VTA, and SCA compliance framework design and implementation.",
      ],
    },
    {
      title: "Compliance Monitoring",
      text: [
        "Ongoing compliance with CFIUS agreements including certifications and audits.",
        "Annual reviews, certification preparation, material change tracking, and compliance verification.",
      ],
    },
  ];

  const integratedCards = [
    {
      title: "Foreign Person Risk Management",
      text: [
        "Unified framework addressing sanctions, CFIUS, and export controls holistically.",
        "Integrated screening, coordinated policies, and single governance structure.",
      ],
    },
    {
      title: "Cross-Border M&A Due Diligence",
      text: [
        "Complete sanctions and CFIUS compliance evaluation with integrated risk assessment.",
        "Comprehensive screening, filing assessment, and integration planning.",
      ],
    },
    {
      title: "Export Control & CFIUS Integration",
      text: [
        "Coordinate ITAR/EAR with CFIUS obligations for cohesive compliance.",
        "Deemed export analysis, technology control plans, and unified governance.",
      ],
    },
    {
      title: "Functional Chief Compliance Officer",
      text: [
        "Executive-level compliance leadership without full-time headcount.",
        "Strategic oversight, program development, staff mentoring (2-4 days/month).",
      ],
    },
  ];

  const retainerTiers = [
    {
      name: "Essential",
      subtitle: "Best for occasional guidance, sanctions focus",
      features: [
        "Priority response",
        "Quarterly strategy sessions",
        "Regulatory monitoring",
        "Email & phone consultations",
      ],
    },
    {
      name: "Professional",
      subtitle: "Best for active international operations",
      features: [
        "Priority response (4 hours)",
        "Quarterly strategy sessions",
        "Full sanctions & CFIUS coverage",
        "Transaction review support",
      ],
      popular: true,
    },
    {
      name: "Enterprise",
      subtitle: "Best for complex, high-volume environments",
      features: [
        "Priority response (4 hours)",
        "Quarterly strategy sessions",
        "Comprehensive support",
        "Multiple business units",
      ],
    },
  ];

  const packageCards = [
    {
      name: "Compliance Starter",
      bullets: [
        "Integrated assessment",
        "Basic policies",
        "2 training sessions",
        "3 months advisory support",
      ],
      best: "Best for companies building initial programs",
    },
    {
      name: "Comprehensive Build",
      bullets: [
        "Full assessment",
        "Complete policy suite",
        "4 training sessions",
        "Compliance audit",
        "6 months advisory support",
      ],
      best: "Best for transforming compliance programs",
    },
    {
      name: "Defense Contractor Complete",
      bullets: [
        "Everything in Comprehensive, plus:",
        "FOCI compliance planning",
        "Export control integration",
        "Technology control plans",
        "12 months advisory support",
      ],
      best: "Best for prime contractors with foreign ownership",
    },
  ];

  const differentiators = [
    {
      icon: "S",
      title: "Deep Industry Knowledge",
      text: "We understand defense operations and government contracting, not just regulations.",
    },
    {
      icon: "G",
      title: "Integrated Expertise",
      text: "Comprehensive capabilities across sanctions, CFIUS, and export controls.",
    },
    {
      icon: "L",
      title: "Practical Guidance",
      text: "Clear, actionable advice enabling compliant business growth.",
    },
    {
      icon: "H",
      title: "Collaborative Approach",
      text: "We work seamlessly with your legal counsel and internal teams.",
    },
    {
      icon: "P",
      title: "Proven Track Record",
      text: "Success with complex transactions and compliance program development.",
    },
    {
      icon: "I",
      title: "Proactive Intelligence",
      text: "Real-time monitoring and early warning of regulatory developments.",
    },
  ];

  return (
    <>
      <Navbar />
      <div className="service-container">
        <h1>Our Services</h1>
        {/* <p>
          At Frigga Consulting Group (FCG), we deliver advisory solutions that
          combine financial governance, compliance, and strategic diplomacy.
          Through our Financial Diplomacy (FinDIP) approach, we help
          governments, institutions, and organizations build resilient,
          transparent, and ethical financial systems.
        </p> */}
        <ul>
          {/* <li>
            <strong>Sanctions Reconsideration & Removal:</strong> Guiding
            clients through OFAC sanctions reconsideration and removal with
            precise, multilingual documentation and culturally informed
            insights.
          </li>
          <li>
            <strong>National Security & Financial Diplomacy Consulting:</strong>{" "}
            Providing strategic guidance that strengthens resilience, promotes
            transparency, and aligns security objectives with global
            cooperation.
          </li>
          <li>
            <strong>OFAC Compliance & Licensing:</strong> Designing and
            enhancing compliance programs while managing license applications
            to ensure lawful transactions under U.S. sanctions.
          </li>
          <li>
            <strong>Sanctions & AML Advisory:</strong> Delivering risk-based
            assessments and mitigation strategies to prevent sanctions evasion
            and financial crime, ensuring robust institutional safeguards.
          </li>
          <li>
            <strong>Law Enforcement & Financial Crime Support:</strong>
            Strengthening investigations through financial forensics,
            cryptocurrency tracing, and global intelligence analysis supported
            by deep expertise in sanctions enforcement, CFIUS matters, and
            regulatory compliance.
          </li>
          <li>
            <strong>Operations & Administrative Support :</strong> Enabling
            clients to achieve their mission through comprehensive operational
            and administrative services, including market research and
            analysis, strategic outreach, proposal development and compliance
            management, budget planning and risk assessment, stakeholder
            consultation, and partnership cultivation.
          </li> */}
        </ul>

        {/* <p className="service-arabic">
          الخدمات الأساسية (Core Services in Arabic) استشارات باللغة العربية
          لدعم عملائنا في مجالات العقوبات، الامتثال، والدبلوماسية المالية وتعزيز
          الشفافية والنزاهة المالية.
        </p> */}

        {/* <div className="service-hero">
          <h2>Sanctions & CFIUS Compliance Advisory</h2>
          <p>
            Expert compliance guidance for defense contractors navigating
            economic sanctions and foreign investment regulations.
          </p>
          <Link className="service-btn" to="/contact">
            Schedule Free Consultation
          </Link>
        </div> */}

        <p className="service-intro">
          The defense industry operates at the intersection of expanding
          sanctions regimes and unprecedented foreign investment scrutiny. We
          provide specialized compliance expertise across both regulations,
          translating complexity into clear, actionable guidance that protects
          your business while enabling compliance, domestic, and international growth.
        </p>

        {/* <p className="service-arabic">
          الخدمات الأساسية (Core Services in Arabic) استشارات باللغة العربية
          لدعم عملائنا في مجالات العقوبات، الامتثال، والدبلوماسية المالية وتعزيز
          الشفافية والنزاهة المالية.
        </p> */}

        <section className="service-block">
          <h2>Sanctions Compliance Services</h2>
          <p className="service-block-subtitle">
            Navigate OFAC regulations and international restrictions with
            expert compliance guidance.
          </p>

          {/* <p className="service-arabic">
            الخدمات الأساسية (Core Services in Arabic) استشارات باللغة العربية
            لدعم عملائنا في مجالات العقوبات، الامتثال، والدبلوماسية المالية وتعزيز
            الشفافية والنزاهة المالية.
          </p> */}

          <div className="service-grid">
            {sanctionsCards.map((card) => (
              <article className="service-card" key={card.title}>
                <h3>{card.title}</h3>
                {card.text.map((line) => (
                  <p key={line}>{line}</p>
                ))}
                {card.note ? <p className="service-note">{card.note}</p> : null}
                <Link to="/contact">Request Information →</Link>
              </article>
            ))}
          </div>
        </section>

        <section className="service-block">
          <h2>CFIUS Services</h2>
          <p className="service-block-subtitle">
            Manage foreign investment compliance and national security
            requirements.
          </p>
          <div className="service-grid">
            {cfiusCards.map((card) => (
              <article className="service-card" key={card.title}>
                <h3>{card.title}</h3>
                {card.text.map((line) => (
                  <p key={line}>{line}</p>
                ))}
                {card.note ? <p className="service-note">{card.note}</p> : null}
                <Link to="/contact">Request Information →</Link>
              </article>
            ))}
          </div>
        </section>

        <section className="service-block">
          <h2>Integrated Solutions</h2>
          <p className="service-block-subtitle">
            Unified approach to foreign person risk across all regulations.
          </p>
          <div className="service-grid service-grid-four">
            {integratedCards.map((card) => (
              <article className="service-card" key={card.title}>
                <h3>{card.title}</h3>
                {card.text.map((line) => (
                  <p key={line}>{line}</p>
                ))}
                <Link to="/contact">Request Information →</Link>
              </article>
            ))}
          </div>
        </section>

        <section className="service-block">
          <h2>Advisory Retainer Services</h2>
          <p className="service-block-subtitle">
            On-demand access to integrated sanctions and CFIUS compliance
            expertise.
          </p>
          <div className="service-tier-grid">
            {retainerTiers.map((tier) => (
              <article
                className={`service-tier${tier.popular ? " service-tier-popular" : ""}`}
                key={tier.name}
              >
                {tier.popular ? (
                  <span className="service-badge">Popular</span>
                ) : null}
                <h3>{tier.name}</h3>
                <p className="service-tier-subtitle">{tier.subtitle}</p>
                <ul>
                  {tier.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>
                <Link className="service-btn" to="/contact">
                  Request Proposal
                </Link>
              </article>
            ))}
          </div>
        </section>

        <section className="service-block">
          <h2>Service Packages</h2>
          <p className="service-block-subtitle">
            Comprehensive solutions tailored to your needs.
          </p>
          <div className="service-package-grid">
            {packageCards.map((pkg) => (
              <article className="service-package-card" key={pkg.name}>
                <h3>{pkg.name}</h3>
                <ul>
                  {pkg.bullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
                <p>{pkg.best}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="service-block">
          <h2>Why Defense Companies Choose Us</h2>
          <div className="service-why-grid">
            {differentiators.map((item) => (
              <article className="service-why-item" key={item.title}>
                <span className="service-icon" aria-hidden="true">
                  {item.icon}
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="service-cta">
          <h2>Ready to Strengthen Your Compliance Program?</h2>
          <p>
            Every company&apos;s risk profile is different. Let&apos;s discuss your
            specific challenges across sanctions, CFIUS, and foreign ownership
            and how we can help.
          </p>
          <p className="service-arabic">
            الخدمات الأساسية استشارات باللغة العربية
            لدعم عملائنا في مجالات العقوبات، الامتثال، والدبلوماسية المالية وتعزيز
            الشفافية والنزاهة المالية.
          </p>
          <Link className="service-btn" to="/contact">
            Schedule Your Free Consultation
          </Link>
          <p className="service-cta-contact">
            Email: contact@friggacg.com
          </p>
        </section>
      </div>
      <Footer />
    </>
  );
}

export default Service;
